import * as Sentry from '@sentry/browser';
import { useEffect, useState } from 'react'
import { useIncodeRemoteConfig } from './use-incode-remote-config'
import { useIncodeSDK } from './use-incode-sdk'

// Hook que inicializa el SDK de Incode
// -----------------------------------------------------------------
let incodeInstanceSingleton = null
let incodeInstancePromise = null

function ensureIncodeStarted() {
  if (incodeInstanceSingleton) {
    return Promise.resolve(incodeInstanceSingleton)
  }

  if (incodeInstancePromise) {
    return incodeInstancePromise
  }

  const ApiIncodeUrl = process.env.REACT_APP_INCODE_URL
  const ApiIncodeKey = process.env.REACT_APP_INCODE_KEY

  try {
    const createdIncode = window.OnBoarding.create({
      apiKey: ApiIncodeKey,
      apiURL: ApiIncodeUrl,
      lang: 'es',
      countryCode: 'MX'
    })

    // create puede retornar una instancia sincronica o una promesa.
    incodeInstancePromise = Promise.resolve(createdIncode)
      .then((incode) => {
        incodeInstanceSingleton = incode
        return incode
      })
      .catch((error) => {
        incodeInstancePromise = null
        throw error
      })
  } catch (error) {
    incodeInstancePromise = null
    return Promise.reject(error)
  }

  return incodeInstancePromise
}

export const useIncode = () => {
  const [incodeInstance, setIncodeInstance] = useState(null)

  // Verifica si verificacion de identidad Incode esta habilitado
  const { incodeEnabled, isLoading } = useIncodeRemoteConfig()
  const { isLoadedSDK } = useIncodeSDK()

  // Inicializa el SDK de Incode
  useEffect(() => {
    if (incodeEnabled && isLoadedSDK && !incodeInstance) {
      ensureIncodeStarted()
        .then((incode) => {
          setIncodeInstance(incode)
          console.clear()
        })
        .catch((error) => {
          Sentry.captureException('Error loading Incode SDK', {
            extra: {
              error: error
            }
          })
        })
    }
  }, [incodeEnabled, isLoadedSDK, incodeInstance])

  return {
    incodeEnabled,
    isLoading,
    incodeInstance
  }
}
